import {InfoCardTargetType} from "../Models/Enums/InfoCardTargetType";
import {RoutePaths} from "../Constants/RoutePaths";

export function buildInternalLink(targetType: InfoCardTargetType, targetId: number) {
    switch (targetType) {
        case InfoCardTargetType.Film:
            return RoutePaths.Watch(targetId);
        case InfoCardTargetType.Series:
            return RoutePaths.SeriesEpisodes(targetId);
        case InfoCardTargetType.Category:
            return RoutePaths.Category(targetId);
        default:
            return "/";
    }
}
